import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { Card, CardBody, CardHeader, Col, Row, Button, Table, Badge } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { MdAdd, MdEdit, MdDelete } from 'react-icons/md';

// components
import Page from '../components/Page';
// My components
import ReactDataTable from '../mycomponents/ReactDataTable';
// lib
import { dateTimeFormat } from '../lib/date';
import toastAlert from '../lib/toastAlert';
// api
import { updateBlogFaqStatus, deleteBlogFaq, getBlogFaq } from '../api/admin';

const BlogFaqList = () => {

    const navigate = useNavigate();
    const { blogId } = useParams();

    const columns = [
        {
            key: "question",
            text: "Question",
            className: "question",
            align: "left",
            sortable: false,
            cell: ({ question }) => {
                if (question.length > 100) {
                    return `${question?.substring(0, 100)}...`
                } else return question;
            }
        },
        {
            key: "answer",
            text: "Answer",
            className: "answer",
            align: "left",
            sortable: false,
            cell: ({ answer }) => {
                if (answer.length > 100) {
                    return `${answer?.substring(0, 100)}...`
                } else return answer;
            }
        },
        {
            key: "status",
            text: "Status",
            className: "status",
            align: "left",
            sortable: false,
            cell: ({ _id, status }) => {
                return (
                    <Badge
                        color={status === 'Active' ? "success" : "danger"}
                        style={{ fontSize: "12px", padding: "10px 16px", borderRadius: "10px", cursor: "pointer" }}
                        onClick={() => handleStatusChange({ _id, status, blogId })}
                    >
                        {status}
                    </Badge>
                )
            }
        },
        {
            key: "createdAt",
            text: "Created At",
            className: "createdAt",
            align: "left",
            sortable: false,
            cell: ({ createdAt }) => {
                return dateTimeFormat(createdAt)
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            align: "left",
            sortable: false,
            cell: state => {
                return (
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <Button
                            color="secondary"
                            onClick={
                                () => navigate('/blog-faq-edit', { state: { ...state, ...{ blogTitle } } })}
                        >
                            <MdEdit />
                        </Button>
                        <Button
                            color="danger"
                            onClick={() => handleDelete({ _id: state?._id, blogId })}
                        >
                            <MdDelete />
                        </Button>
                    </div>
                )
            }
        }
    ];


    // state
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [blogTitle, setBlogTitle] = useState("");
    const [pagination, setPagination] = useState({ page: "", limit: "", search: "" });
    // const { page, limit, search } = pagination;

    const handleStatusChange = async (data) => {
        try {
            let { status, message } = await updateBlogFaqStatus(data);
            if (status === true) {
                toastAlert('success', message, 'updateBlogFaqStatus')
                fetchData();
            }
        } catch (error) { }
    }

    const handleDelete = async (data) => {
        try {
            if (window.confirm('Are you sure want to delete this faq?')) {
                let { status, message } = await deleteBlogFaq(data);
                if (status === true) {
                    toastAlert('success', message, 'deleteBlogFaq')
                    fetchData();
                }
            }
        } catch (error) { }
    }

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const { status, result } = await getBlogFaq({ ...pagination, ...{ blogId } });
            setLoader(false);
            if (status === true) {
                setData(result.data)
                setCount(result.count)
                setBlogTitle(result.blogTitle)
            }
        } catch (err) { }
    }, [pagination])

    useEffect(() => {
        fetchData()
    }, [pagination, fetchData])

    return (
        <Page
            title="Blog FAQ List"
            breadcrumbs={[{ name: 'Blog FAQ List', active: true }]}
            className="TablePage"
        >
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader className="d-flex align-items-center justify-content-between">
                            <span>Blog FAQ List- ({blogTitle})</span>
                            <Button color="primary" onClick={() => navigate('/blog-faq-add', { state: { blogId, blogTitle } })}><MdAdd />Add</Button>
                        </CardHeader>
                        <CardBody>
                            <Table responsive={false}>
                                <ReactDataTable
                                    columns={columns}
                                    records={data}
                                    count={count}
                                    loader={loader}
                                    setPagination={setPagination}
                                />
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};

export default BlogFaqList;